import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AdminGate() {
    const nav = useNavigate();
    useEffect(() => {
        api.get("/auth/setup-required")
            .then((r) => nav(r.data.required ? "/admin/setup" : "/admin/login", { replace: true }))
            .catch(() => nav("/admin/login", { replace: true }));
    }, [nav]);
    return (
        <div className="min-h-screen flex items-center justify-center text-brand-ink/60">
            Chargement...
        </div>
    );
}
